module.exports = __webpack_public_path__ + "static/rowIcon2.b3034649.svg";